import { JsonObject, JsonProperty } from 'json2typescript';

import { CityInterface } from '../../../core';
import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('City')
export class City implements CityInterface {
    @JsonProperty('Id', IdAdapter, true)
    private _id: Id = undefined;

    @JsonProperty('Name', StringAdapter, true)
    private _name: string = undefined;

    get id(): Id {
        return this._id;
    }

    get name(): string {
        return this._name;
    }
}
